export default "__VITE_ASSET__DlbDq0s___"